export const hirePageData = {
  hero: {
    badge: "Hire Laravel Developers",
    headline: "Hire Expert Laravel Developers",
    subtext: "Get experienced Laravel developers to build, scale and maintain your digital products.",
    primaryCTA: "Hire Laravel Developer",
    secondaryCTA: "Discuss Your Requirements",
    image: "https://readdy.ai/api/search-image?query=Professional%20software%20development%20team%20working%20collaboratively%2C%20multiple%20monitors%20showing%20Laravel%20code%2C%20blue%20and%20purple%20gradient%20lighting%2C%20modern%20tech%20office%20environment%2C%20abstract%20technology%20aesthetic%2C%20no%20text%2C%20no%20people&width=1400&height=800&seq=hire-hero-1&orientation=landscape",
  },
  engagementModels: [
    {
      title: "Dedicated Laravel Developer",
      subtitle: "For businesses that need an experienced Laravel developer.",
      desc: "A single experienced Laravel developer working exclusively on your project. Ideal for ongoing development, maintenance and feature additions.",
      icon: "ri-user-star-line",
      highlight: "Monthly Retainer",
      features: ["Full-time dedicated developer", "40+ hours per week", "Daily standups", "Code reviews", "Sprint planning"],
    },
    {
      title: "Project-Based Development",
      subtitle: "For clearly defined applications and projects.",
      icon: "ri-folder-line",
      highlight: "Fixed Price / Milestone",
      desc: "Best for projects with a clear scope, timeline and deliverables. We agree on milestones and deliverables upfront.",
      features: ["Defined scope & timeline", "Milestone-based billing", "Agile sprints", "Weekly demos", "Post-launch support"],
    },
    {
      title: "Dedicated Development Team",
      subtitle: "For complex long-term digital products.",
      icon: "ri-team-line",
      highlight: "Full Team",
      desc: "A full team including Laravel developers, frontend engineers, QA and a project manager. Built for long-term product development.",
      features: ["Full team dedicated to you", "Project manager included", "Laravel + Frontend + QA", "Scrum methodology", "Continuous delivery"],
    },
  ],
  whyAstroJal: [
    { title: "Experienced Laravel Developers", desc: "Deep expertise in Laravel, PHP and modern web technologies.", icon: "ri-user-star-line" },
    { title: "Flexible Engagement", desc: "Choose the engagement model that fits your business needs.", icon: "ri-refresh-line" },
    { title: "Transparent Communication", desc: "Clear, regular updates and transparent project management.", icon: "ri-chat-3-line" },
    { title: "Clean Code", desc: "Well-structured, maintainable and thoroughly tested code.", icon: "ri-file-code-line" },
    { title: "Scalable Architecture", desc: "Systems designed to grow with your business.", icon: "ri-expand-diagonal-line" },
    { title: "Performance Focus", desc: "Optimized for speed, efficiency and user experience.", icon: "ri-speed-line" },
    { title: "Security", desc: "Industry-standard security practices at every layer.", icon: "ri-shield-check-line" },
    { title: "Long-Term Support", desc: "Ongoing maintenance and optimization after launch.", icon: "ri-heart-3-line" },
  ],
  skills: [
    { name: "Laravel", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg", featured: true },
    { name: "PHP", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg" },
    { name: "MySQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original.svg" },
    { name: "PostgreSQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg" },
    { name: "Redis", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redis/redis-original.svg" },
    { name: "REST APIs", icon: "ri-exchange-line" },
    { name: "Vue.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuejs/vuejs-original.svg" },
    { name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg" },
    { name: "AWS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg" },
    { name: "Docker", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg" },
    { name: "Git", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-original.svg" },
    { name: "CI/CD", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/githubactions/githubactions-original.svg" },
  ],
  process: [
    { number: "01", title: "Requirement Gathering", desc: "We understand your project requirements, timeline and team needs." },
    { number: "02", title: "Developer Selection", desc: "We match you with Laravel developers who have the right skills for your project." },
    { number: "03", title: "Planning & Setup", desc: "Define the project roadmap, tools, communication channels and sprint structure." },
    { number: "04", title: "Development", desc: "Agile sprints with regular demos, code reviews and progress updates." },
    { number: "05", title: "Testing & QA", desc: "Comprehensive testing, security audits and performance checks." },
    { number: "06", title: "Deployment", desc: "Production deployment with CI/CD, monitoring and documentation." },
    { number: "07", title: "Ongoing Support", desc: "Continuous maintenance, bug fixes and feature enhancements." },
  ],
};